
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

interface AnimatedLogoProps {
  size?: 'sm' | 'md' | 'lg';
  showTitle?: boolean;
  onClick?: () => void;
  animationEnabled?: boolean;
}

const AnimatedLogo: React.FC<AnimatedLogoProps> = ({ 
  size = 'md', 
  showTitle = true, 
  onClick, 
  animationEnabled = true
}) => {
  const sizes = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16'
  };

  return (
    <Link to="/" onClick={onClick} className="flex items-center">
      <div className={`relative ${sizes[size]}`} style={{ perspective: '800px' }}>
        <motion.img
          src="/lovable-uploads/1dd5a01c-f447-44fa-821e-b0951b6ade29.png"
          alt="NALC Logo"
          className={`w-full h-full object-contain`}
          style={{ 
            transformStyle: 'preserve-3d',
            backfaceVisibility: 'visible'
          }}
          animate={animationEnabled ? {
            rotateY: [0, 360],
            rotateX: [0, 10, 0, -10, 0],
            scale: [1, 1.05, 1]
          } : {}}
          transition={animationEnabled ? {
            duration: 10,
            ease: "easeInOut",
            repeat: Infinity,
            repeatDelay: 0.5
          } : {}}
        />
      </div>
      
      {showTitle && (
        <div className="flex flex-col ml-3">
          <h1 className="text-xl font-bold">NALC</h1>
          <p className="text-xs text-slate-400">Noor Ali Learning Center</p>
        </div>
      )}
    </Link>
  );
};

export default AnimatedLogo;
